import Base from './Base';
import CustomField from '../models/CustomField';

export default class CustomFields extends Base {
    get models() {
        const collection = this.data.map(item => new CustomField(item));
        collection.collection = this;

        return collection;
    }
}
